import MultiScopePickerWrapper, {
  type MultiScopePickerWrapperProps,
} from '../multi-scope-picker-2/MultiScopePickerWrapper.tsx'
import {
  RetailerAndSitePickerWrapper,
  type RetailerScopeWrapperProps,
} from '../retailer-and-site-picker/RetailerAndSitePickerWrapper.tsx'
import useAccessControl from '../../../legacy/components/AccessControl/useAccessControl.ts'
import { type AccessControlConfig } from '../../../legacy/components/AccessControl/accessControl.utils'
import { ICPlatformVersion } from '../../../utils/ic-platform/versioning/versions.constants'
import { type FeatureToggle } from '../../../legacy/contexts/featureToggles/FeatureToggleContext'
import { ViewType } from './ScopeSelection.types.ts'
import { ScopeSelectorProvider } from './ScopeSelectorContext.tsx'

export interface ScopeSelectorProps
  extends MultiScopePickerWrapperProps,
    RetailerScopeWrapperProps {
  margin?: string
}

const scopePickerV2Access: AccessControlConfig = {
  featureToggles: ['rt_scope_picker_v2' as FeatureToggle],
  minICPlatformVersion: ICPlatformVersion.r2025_05_0,
}

/**
 * Wrap the V1 and V2 scope selector components in a single component
 * We render the V2 version of the selector if users have the 'rt_scope_picker_v2' feature flag
 */
export const ScopeSelector = ({
  /* V1 and V2 props */
  selectionType = ViewType.RETAILER,
  retailerSelectionOptional,
  storeConfigOperationIntent,
  storeConfigFilter,
  margin,
  /* V1 only props */
  retailerInsufficientPermission,
  /* V2 only props */
  multiSelect,
  allowNotVisibleToPartnersStoreConfigs,
}: ScopeSelectorProps) => {
  const hasAccess = useAccessControl()
  const scopePickerV2Enabled = hasAccess(scopePickerV2Access)

  return (
    <ScopeSelectorProvider margin={margin}>
      {scopePickerV2Enabled ? (
        <MultiScopePickerWrapper
          selectionType={selectionType}
          multiSelect={multiSelect}
          scopeSelectionOptional={retailerSelectionOptional}
          storeConfigOperationIntent={storeConfigOperationIntent}
          storeConfigFilter={storeConfigFilter}
          allowNotVisibleToPartnersStoreConfigs={allowNotVisibleToPartnersStoreConfigs}
        />
      ) : (
        <RetailerAndSitePickerWrapper
          selectionType={selectionType}
          retailerSelectionOptional={retailerSelectionOptional}
          storeConfigOperationIntent={storeConfigOperationIntent}
          storeConfigFilter={storeConfigFilter}
          retailerInsufficientPermission={retailerInsufficientPermission}
        />
      )}
    </ScopeSelectorProvider>
  )
}
